import { api, Api } from '@/services/api';
import type { UpdateUserParams, User } from '@/types';

const usersEndpoints = api.injectEndpoints({
  endpoints: (builder) => ({
    userDetails: builder.query<User, { id: number }>({
      query: ({ id }) => ({ url: `${Api.Users}/${id}` }),
      providesTags: (_r, _e, { id }) => [{ type: 'Users', id }],
    }),
    usersMe: builder.query<User, void>({
      query: () => ({ url: `${Api.Users}/me` }),
      providesTags: ['Users'],
    }),
    deleteUsersMe: builder.mutation<unknown, { token: string }>({
      query: (params) => ({
        url: Api.UsersDelete,
        method: 'POST',
        body: { token: params.token },
      }),
    }),
    updateUser: builder.mutation<unknown, UpdateUserParams>({
      query: (params) => ({
        url: Api.UpdateUsers.replace(':id', params.id.toString()),
        method: 'PUT',
        body: { ...params },
      }),
      invalidatesTags: ['Users'],
    }),
    updateAvatar: builder.mutation<unknown, { id: number; body: FormData }>({
      query: (params) => ({
        url: Api.UpdateAvatar.replace(':id', params.id.toString()),
        method: 'POST',
        body: params.body,
      }),
      invalidatesTags: ['Users'],
    }),
  }),
});

export const {
  useUserDetailsQuery,
  useUsersMeQuery,
  useLazyUsersMeQuery,
  useDeleteUsersMeMutation,
  useUpdateUserMutation,
  useUpdateAvatarMutation,
} = usersEndpoints;
